import { t } from '@lingui/macro';
import IconChevronDown from '@we-make-websites/ui-lib/icons/direction/chevron/down.svg';
import {
  DropdownButton,
  DropdownList,
  DropdownMenu,
} from '../dropdownMenu/DropdownMenu';
import type { StoreFilterSetting } from '../globalContentContext/GlobalContentContext';
import { CustomRefinementList } from './CustomRefinementList';
import styles from './Filters.module.scss';

export const Filters = ({ filters }: { filters: StoreFilterSetting[] }) => {
  return (
    <div className={styles.filters}>
      {filters.map((filter) => (
        <DropdownMenu
          key={filter.attribute}
          className={
            filter.displaySwatches ? styles['filters__menu--large'] : ''
          }
        >
          <DropdownButton
            className={styles.filters__menuButton}
            title={filter.label}
            aria-label={t({
              id: 'filters.dropdown.label',
              message: `Filter by ${filter.label}, opens drop down`,
            })}
          >
            <span className="text-utility-utility">{filter.label}</span>
            <IconChevronDown />
          </DropdownButton>
          <DropdownList className={styles.filters__menuList}>
            <CustomRefinementList
              attribute={filter.attribute}
              limit={50}
              sortBy={['count:desc', 'name:asc']}
              filter={filter}
            />
          </DropdownList>
        </DropdownMenu>
      ))}
    </div>
  );
};
